import React from 'react';
import { Interview } from '../../../entities/Interview';
import { CloseableModal } from '../../../components/CloseableModal';
import { ShareModalBody } from './ShareModalBody';
import { Button } from 'reactstrap';

interface PropTypes {
  interview: Interview;
  isOpen: boolean;
  onClose: () => void;
}

interface ModalProps {
  interview: Interview;
  onClose: () => void;
}

function ModalBody(props: ModalProps) {
  return (
    <div>
      <ShareModalBody interview={props.interview} />
      <div className='d-flex justify-content-end'>
        <Button type='button' color='secondary' onClick={props.onClose}>
          Close
        </Button>
      </div>
    </div>
  );
}

export function ShareModal(props: PropTypes) {
  return (
    <>
      {props.isOpen && (
        <CloseableModal
          className='modal-dialog-top'
          onClose={() => props.onClose()}
          isOpen={true}
          style={{ width: 'auto' }}
          size='md'
          modalHeaderTag='div'
          headerClassName='p-4 bg-gray'
          contentClassName='rounded-3'
          bodyClassName='p-4'
          closeButtonClassName='me-0'
          closeDisabled={false}
          keyboard={true}
          backdrop={true}
          headerChildren={<h3 className='m-0'>Share Interview</h3>}
          bodyChildren={
            <ModalBody interview={props.interview} onClose={props.onClose} />
          }
        />
      )}
    </>
  );
}
